import { prodapiAxiosClient } from "./prodApiClient";

const logInfo = (logData) => {
    return prodapiAxiosClient
    .post("/api/v1/log", logData)
}

const logApi = { logInfo }
export default logApi;